import { render } from "./InternalLayout.vue?vue&type=template&id=6db29aec&ts=true"
import script from "./InternalLayout.vue?vue&type=script&lang=ts"
export * from "./InternalLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__